"use strict";

import React, {createRef} from "react";

import {PasswordInput} from "@/components/passwordInput/PasswordInput.tsx";
import {FieldErrors, FieldHelpText, Label, uniqueHtmlId, unpackFormLinkOrProps} from "@/legacy/form/FormHelpers.jsx";

export default class ShowPassword extends React.Component {
  constructor(props) {
    super(props);
    this.htmlId = uniqueHtmlId(props.fieldName);
    this.showPassword = createRef();
  }

  focus() {
    const input = this.showPassword.current;
    const length = input.value.length;
    input.focus();

    // place cursor at the end of the string
    input.setSelectionRange(length, length);
  }

  render() {
    const form = unpackFormLinkOrProps(this.props);

    return (
      <div className="form-group">
        <Label fieldId={this.htmlId} {...this.props} />
        <PasswordInput
          ref={this.showPassword}
          id={this.htmlId}
          name={form.fieldName}
          invalid={!!form.errors}
          autoComplete="new-password"
          disabled={this.props.disabled}
          maxLength={this.props.maxLength}
          value={form.value}
          onChange={form.onChange}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
        <FieldErrors errors={form.errors} />
        <FieldHelpText {...this.props} />
      </div>
    );
  }
}

ShowPassword.defaultProps = {
  fieldName: null, // Field name returned in form data
  labelText: null, // Label of this field
  titleText: null, // Tooltip
  helpText: null, // Help text beneath the field
  isRequired: false, // Field is required?
  disabled: false, // Control is disabled?
  maxLength: null, // HTML maxlength for this field

  formLink: null, // Object from prepareFormLink() to auto-bind value, onChange, formErrors
  value: null, // React field value
  formErrors: null, // Dict of all form errors, possibly with an entry for fieldName

  onChange: null, // Change handler
  onFocus: null, // Focus handler
  onBlur: null, // Blur handler
};
